import { render, staticRenderFns } from "./InboundRemarkForm.vue?vue&type=template&id=f47bf1f2&scoped=true"
import script from "./InboundRemarkForm.vue?vue&type=script&lang=js"
export * from "./InboundRemarkForm.vue?vue&type=script&lang=js"
import style0 from "./InboundRemarkForm.vue?vue&type=style&index=0&id=f47bf1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47bf1f2",
  null
  
)

export default component.exports